import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfl_J4_FTX } from "../../../modules/Beräkningsmoduler/BFL_J4_FTX";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { IJ4_FTX_FT_BFData } from "../../../types/BFDatas";
import { Card, Table } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFL_J4_FTX = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfl_J4_FTX().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const j4Data = bm.data as IJ4_FTX_FT_BFData | undefined;
  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = global.beräkningsflikarText.beskr_BFL_J4_FTX;

  return (
    <>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div className="mb-3" dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />

          {j4Data ? (
            <>
              <div className="col col-lg-6 mb-3">
                <Card>
                  <Card.Header className="ps-3 pt-3">Verkningsgrad</Card.Header>
                  <Table striped bordered hover>
                    <tbody>
                      <tr>
                        <td>Uppmätt temperaturverkningsgrad</td>
                        <td>{new Intl.NumberFormat("sv-SE", { maximumSignificantDigits: 2 }).format(j4Data.export.uppmättTemperaturverkningsgrad * 100)} %</td>
                      </tr>
                      <tr>
                        <td>Förväntad temperaturverkningsgrad</td>
                        <td>{new Intl.NumberFormat("sv-SE", { maximumSignificantDigits: 2 }).format(j4Data.export.förväntadTemperaturverkningsgrad * 100)} %</td>
                      </tr>
                    </tbody>
                  </Table>
                </Card>
              </div>
            </>
          ) : (
            <></>
          )}
          <Funktionskontroller bfName="BFL_J4_FTX" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </>
  );
};

export default BFL_J4_FTX;
